var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 216,
    width: 478,
    height: 74,
    fill: "#EE1C34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.567 206.769H30.471C14.231 206.769 0 219.344 0 235.623V275.046C0 291.325 14.231 305.231 30.471 305.231H483.567C499.808 305.231 512 291.325 512 275.046V235.623C512 219.344 499.808 206.769 483.567 206.769ZM492.308 275.046C492.308 280.464 488.952 285.539 483.568 285.539H30.471C25 285.539 19.692 280.556 19.692 275.046V235.623C19.692 230.206 25.086 226.462 30.471 226.462H483.567C489.038 226.462 492.307 230.113 492.307 235.623V275.046H492.308Z",
    fill: "#500B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.b4c6fe786b38893f3f240bd262b14952.svg";
export { ForwardRef as ReactComponent };